import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { NavItemMinimizable } from '@feathr/components';
import GrowthCreditIcon from '@feathr/extender/components/GrowthCreditIcon/GrowthCreditIcon';
import { useLocalUrl } from '@feathr/extender/state';

function CreditsNavItem(): JSX.Element {
  const { t } = useTranslation();
  const localUrl = useLocalUrl();

  return (
    <NavItemMinimizable
      data-command={'true'}
      data-command-description={t('View growth credits')}
      data-command-keywords={'credits,growth,balance'}
      data-command-label={t('Growth Credits')}
      icon={<GrowthCreditIcon />}
      isMinimized={true}
      label={t('Credits')}
      to={localUrl('/fundraise/growth-credits')}
    />
  );
}

export default CreditsNavItem;
